import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// GET/PUT /api/v3/menu-permissions/access-levels/{accessLevelId}
// (Menus/swagger) — endpoint real, confirmado em 07/08/2026.
const menuPermissionsBasePath = `${API_URLS.MENUS}/menu-permissions/access-levels`;

// PLACEHOLDER — não existe (ainda) endpoint de criação de nível de acesso.
// Mantido apenas para o fluxo "Criar Perfil" ficar pronto assim que existir;
// ajustar basePath/campos quando o backend definir o contrato.
const createProfileBasePath = `${API_URLS.AUTH}/v3/AccessProfiles`;

async function createProfile(name) {
  try {
    const payload = { Name: name };
    const response = await api.post(createProfileBasePath, JSON.stringify(payload));

    let treated = errorHandling.handleResponse(
      response,
      "profilePermissionsService.createProfile"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "profilePermissionsService.createProfile");
    return null;
  }
}

// GET /api/v3/menu-permissions/access-levels/{accessLevelId}
// Resposta: lista de { MenuId, Level, Name, Active } — Active "S"/"N",
// indicando se o menu está vinculado a este nível de acesso.
async function fetchMenuPermissions(accessLevelId) {
  try {
    const response = await api.get(`${menuPermissionsBasePath}/${accessLevelId}`);

    let treated = errorHandling.handleResponse(
      response,
      "profilePermissionsService.fetchMenuPermissions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "profilePermissionsService.fetchMenuPermissions");
    return null;
  }
}

// PUT /api/v3/menu-permissions/access-levels/{accessLevelId}
// Payload: { AccessLevelId, MenuId, Active: "S" | "N" }
async function setMenuPermission(accessLevelId, menuId, active) {
  try {
    const payload = {
      AccessLevelId: accessLevelId,
      MenuId: menuId,
      Active: active ? "S" : "N",
    };
    const response = await api.put(
      `${menuPermissionsBasePath}/${accessLevelId}`,
      JSON.stringify(payload)
    );

    if (response?.status === 204) {
      return { success: true };
    }

    let treated = errorHandling.handleResponse(
      response,
      "profilePermissionsService.setMenuPermission"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "profilePermissionsService.setMenuPermission");
    return null;
  }
}

export const profilePermissionsService = {
  createProfile,
  fetchMenuPermissions,
  setMenuPermission,
};
